export default __webpack_public_path__ + "static/media/gridIcon.723307fc.svg";